import React, { useEffect } from "react";
import {
  makeStyles,
  Container,
  Box,
  CardHeader,
  Card,
  Divider,
  CardContent,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";

import { AlertTitle, Alert } from "@material-ui/lab";

import _ from "lodash";
import {
  getAllPermissions,
  addPermission,
  updatePermission,
  deletePermission,
} from "src/redux/actions/backOffice.action";
import Page from "src/components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    maxWidth: "120%",
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const PermissionManagementSettingComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { permissions } = useSelector((state) => state.backOfficeReducer);

  useEffect(() => {
    dispatch(getAllPermissions());
  }, []);

  if (permissions.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get permissions data!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="Permission Management">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the permission management on the system."
            title="Permission Management"
          />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  isLoading={permissions.isLoading}
                  columns={[
                    {
                      title: "Name",
                      field: "NAME",
                    },
                    {
                      title: "Value Number Permission",
                      field: "VALUE_NUMBER",
                      type: "numeric",
                    },
                    {
                      title: "Value Text Permission",
                      field: "VALUE_TEXT",
                    },
                    {
                      title: "Create Date",
                      field: "CREATED_AT",
                      type: "date",
                      editable: false,
                      defaultSort: "desc",
                    },
                  ]}
                  data={permissions.data}
                  editable={{
                    onRowAdd: (newData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          dispatch(addPermission(newData));
                          resolve();
                        }, 1000);
                      }),
                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          dispatch(updatePermission(newData.ID, newData));
                          resolve();
                        }, 1000);
                      }),
                    onRowDelete: (oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          dispatch(deletePermission(oldData.ID));
                          resolve();
                        }, 1000);
                      }),
                  }}
                  options={{
                    filtering: true,
                    actionsColumnIndex: -1,
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default PermissionManagementSettingComponent;
